import { VOXTORPGLOBALNAME, FRAMECATEGORY } from '../utils/kitchenConfig';
import { isHighFrameTopPart } from '../utils/renderUtils';
class VoxtorpDoor {
    constructor(frame, door, child, scene) {
        this.frame = frame;
        this.door = door;
        this.child = child;
        this.scene = scene;
    }
    /**
     * @description: 旋转顶柜门板180°,并将门板上移门板相应的高度
     * @param  {bool} move 是否需要上移，多次替换沃拓普门板是不需要上移的
     * @return {*}
     * @author: Yongchao Wang
     */
    rotateTopDoor(move = true) {
        var _a;
        const rotation = { x: 0, y: 0, z: Math.PI };
        this.child.addRotation(rotation.x, rotation.y, rotation.z);
        // 顶柜转角柜，沃拓普门板旋转后要再转一下
        if (((_a = this === null || this === void 0 ? void 0 : this.frame) === null || _a === void 0 ? void 0 : _a.categoryId) === FRAMECATEGORY.CATEGORY_9) {
            this.child.addRotation(0, Math.PI / 2, 0);
        }
        if (move) {
            const { position } = this.child.mesh;
            this.child.setModelPosition({
                x: position.x,
                y: position.y + this.child.getModelSize().y,
                z: position.z,
            });
        }
        return rotation;
    }
    /**
     * @description: 旋转高柜柜门
     * @param {number} index
     * @param {Rotation} preHighDoorRotation
     * @param {MeshManage} preMesh
     * @param {boolean} needMoveUp
     * @return {*}
     * @author: Yongchao Wang
     */
    rotateHighFrameDoor(index, preHighDoorRotation, preMesh, needMoveUp = true) {
        const { categoryId } = this.frame;
        let rotation = { x: 0, y: 0, z: 0 };
        const isTop = isHighFrameTopPart(VOXTORPGLOBALNAME, categoryId, index);
        // const isTop = false;
        // 如果是高柜的中部或者顶部，需要旋转门板
        if (isTop) {
            rotation = { x: 0, y: 0, z: Math.PI };
            this.child.addRotation(rotation.x, rotation.y, rotation.z);
            let moveDownDis = 0;
            if (preHighDoorRotation.z) {
                moveDownDis = preMesh.getModelSize().y;
            }
            if (needMoveUp) {
                const { position } = this.child.mesh;
                this.child.setModelPosition({
                    x: position.x,
                    y: position.y + this.child.getModelSize().y - moveDownDis,
                    z: position.z,
                });
            }
        }
        return rotation;
    }
    /**
     * @description: 是否为沃拓普系列
     * @param {Top} top
     * @return {*}
     * @author: Yongchao Wang
     */
    static isVoxtorpDoor(top) {
        if ((top === null || top === void 0 ? void 0 : top.globalName) === VOXTORPGLOBALNAME) {
            return true;
        }
        return false;
    }
}
export default VoxtorpDoor;
